module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABIUlEQVRIS+2WMU4DMRBF/6eI0pGCA3AAJPYG4QihwC1MtZsOTgA3IF20NJMO7VJEnIBwBAqOESmUUGSQVwJWaCNZybINdmnL/3lm/tgmOh7chTfV+8M++iuR01WoztbAXB8uQbv1oLVBxuJmIdAdgOUCxNBDzPCYiRt1BoThORV3EoE+A63UMKa0bqaY0o2tletP40fTRNOE3MH4H6Yx2pCgfw9fMnFJSGqCbpo7LRMjngAMmkTXhuVY3EFrwFyLG5DXmwTN8JaJazzM7z1BEeZajEDOOwN60FTLiz1Cm6CtR/gFqWoJ+M/Tfh1shmXWZg3r4qrzwTs+FiSPv+cNr6m4o9ZM0ySUazEDeV6tGa9SOZv8KdCLV2YCkh56k9Df9yfigq8dUydNaAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/course/editSourceIcon/down.png
// module id = VTEZ
// module chunks = 96